import { alpha, Box, Paper, Typography } from "@mui/material";
import { WebIntelligenceResponse } from "../../../services/agent.service";
import { ProductMetadata } from "./types";
import { InfoRow, ProductStatus, Section, CreatedBy, CrmProductInfo, AttachedFiles } from "./common";
import { format } from "date-fns";

const WebIntelligenceDetails: React.FC<{
  productInfo: WebIntelligenceResponse;
  productMetaData: ProductMetadata;
  onUpdateProduct: (product: WebIntelligenceResponse) => void;
}> = ({ productInfo, productMetaData, onUpdateProduct }) => {
  const { createdBy, product } = productInfo;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <CrmProductInfo productCrm={productInfo.productCrm} />

      {/* Basic Info */}
      <Section title="Details">
        <InfoRow label="Created at" value={format(product.createdAt, "yyyy-MM-dd HH:mm")} />
        <InfoRow label="Updated at" value={format(product.updatedAt, "yyyy-MM-dd HH:mm")} />
        <InfoRow label="Product Request ID" value={product.productRequestId} />
        <InfoRow label="Transaction ID" value={product.transactionId} />
        <InfoRow label="PDF URL" value={product.pdfUrl} />
      </Section>

      {/* Client Details */}
      <Section title="Client Details">
        <InfoRow label="Full Name" value={product.fullName} />
        <InfoRow label="Country" value={`🌍 ${product.country}`} />
        <InfoRow label="Email" value={product.email} />
        <InfoRow label="User ID (DB)" value={product.userId} />
        <InfoRow label="User ID (CRM)" value={product.crmProfileId} />
      </Section>

      {/* Created By */}
      <CreatedBy createdBy={createdBy} />

      {/* Form Data */}
      {product.formData && Object.keys(product.formData).length > 0 && (
        <Section title="Form Data">
          {Object.entries(product.formData).map(([key, value]) => (
            <InfoRow key={key} label={key.charAt(0).toUpperCase() + key.slice(1)} value={value} />
          ))}
        </Section>
      )}

      {/* Attached Files */}
      <AttachedFiles attachments={productInfo.attachments} productMetaData={productMetaData} />

      {/* Error */}
      {product.error && (
        <Paper sx={{ p: 2, bgcolor: alpha("#f44336", 0.1), border: `1px solid ${alpha("#f44336", 0.2)}`, borderRadius: 1.5, overflowX: "auto" }}>
          <Typography variant="subtitle2" sx={{ color: "#d32f2f", mb: 1, fontSize: "0.85rem" }}>
            Error
          </Typography>
          <Typography variant="caption" sx={{ color: "#d32f2f" }}>
            {product.error}
          </Typography>
        </Paper>
      )}

      {/* Process Status */}
      <ProductStatus productInfo={productInfo} productMetaData={productMetaData} onProductUpdate={onUpdateProduct} />
    </Box>
  );
};

export default WebIntelligenceDetails;
